import { fetchUserRefId } from 'lib/models/users';
import { useCallback, useEffect, useState } from 'react';

function useUserRefId(username: string) {
	const [loading, setLoading] = useState<boolean>(true);
	const [refId, setRefId] = useState<string>('');

	const refetch = useCallback(async () => {
		const response = await fetchUserRefId(username);
		setRefId(response);
		setLoading(false);
	}, [username]);

	useEffect(() => {
		refetch();
	}, [refetch]);

	return { loading, refId, refetch, setLoading };
}

export default useUserRefId;
